// 获取当前系统时间'2019-05-20 15:30:29'
export const dateTime = () => {
    const myDate = new Date();
    const date = myDate.getFullYear() + '-' +
        (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1) + '-' +
        (myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()) + ' ' +
        (myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours()) + ':' +
    (myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes()) + ':' +
        (myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds());
    return date;
};